import React, { useEffect, useRef } from 'react';
import { Hero } from '../components/Hero';
import { DoctorIntro } from '../components/DoctorIntro';
import { WhatToExpect } from '../components/WhatToExpect';
import { LegalInformation } from '../components/LegalInformation';
import { ProfessionalAffiliation } from '../components/ProfessionalAffiliation';
import { LeadForm } from '../components/LeadForm';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { initMetaPixel } from '../utils/metaPixel';
export function DermaclinicLanding() {
  const formRef = useRef<HTMLDivElement>(null);
  // Initialize Meta Pixel on mount
  useEffect(() => {
    initMetaPixel('1329531075115236');
  }, []);
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <main className="w-full min-h-screen" data-id="element-468">
      <Hero onCtaClick={scrollToForm} data-id="element-469" />
      <DoctorIntro data-id="element-470" />
      <WhatToExpect data-id="element-471" />
      <LegalInformation data-id="element-472" />
      <ProfessionalAffiliation data-id="element-473" />
      <div ref={formRef} data-id="element-474">
        <LeadForm data-id="element-475" />
      </div>
      <FAQ data-id="element-476" />
      <FinalCTA onCtaClick={scrollToForm} data-id="element-477" />
    </main>;
}